class ColorsUtils {
  rgbaToHex(rgba, forceRemoveAlpha = false) {
    return (
      '#' +
      rgba
        ?.replace(/^rgba?\(|\s+|\)$/g, '')
        .split(',')
        .filter((_, index) => !forceRemoveAlpha || index !== 3)
        .map(string => parseFloat(string))
        .map((number, index) => (index === 3 ? Math.round(number * 255) : number))
        .map(number => number.toString(16))
        .map(string => (string.length === 1 ? '0' + string : string))
        .join('')
    )
  }

  isRgbColor(color) {
    return color?.startsWith('rgb')
  }

  isSameColor(colorAsRGBAOrHexA, colorAsRGBAOrHexB) {
    const colorA = this.isRgbColor(colorAsRGBAOrHexA) ? this.rgbaToHex(colorAsRGBAOrHexA) : colorAsRGBAOrHexA
    const colorB = this.isRgbColor(colorAsRGBAOrHexB) ? this.rgbaToHex(colorAsRGBAOrHexB) : colorAsRGBAOrHexB
    const colorAInLowerCase = colorA.toLowerCase()
    const colorBInLowerCase = colorB.toLowerCase()

    return colorAInLowerCase === colorBInLowerCase
  }
}

export const colorsUtils = new ColorsUtils()
